import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { PlanDuplicationRequestEntity } from 'src/entities/PlanDuplication.request.entity';

const requestPath = (planningOn: string) => `/api/v3/plannings/${planningOn}/duplication`;

export const usePlanDuplicationRequestMutation = () => ({
  create: useMutation((dto: PlanDuplicationRequestEntity) => axios.post(requestPath(dto.planning_on), dto))
});
